import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { editProduct } from "../api";

export const useEditProduct = () => {
  const router = useNavigate();
  const queryClient = useQueryClient();
  const { mutate, isPending } = useMutation({
    mutationFn: editProduct,
    onSuccess() {
      queryClient.refetchQueries({ queryKey: ["PRODUCT"] });
      queryClient.refetchQueries({ queryKey: ["PRODUCT-ALL"] });
      router("/product");
      toast.success("Success Create Product");
    },
  });

  return { edit: mutate, isPending };
};
